/*
 * File: appSlice.ts
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 3:32:53 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'models/Application';

const initialState: AppState = {
  showLoader: false,
  application: null,
  user: null,
  acuityContext: null,
  accessToken: null,
  company: null,
  bulkSearchResults: undefined,
  postRequestLoadingMessage: undefined
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    showLoader(state, action: PayloadAction<AppState['showLoader']>): void {
      state.showLoader = action.payload;
    },
    setUser(state, action: PayloadAction<AppState['user']>): void {
      state.user = action.payload;
    },
    setAcuityContext(state, action: PayloadAction<AppState['acuityContext']>): void {
      state.acuityContext = action.payload;
    },
    setAccessToken(state, action: PayloadAction<AppState['accessToken']>) {
      state.accessToken = action.payload;
    },
    setPostRequestLoadingMessage(state, action: PayloadAction<AppState['postRequestLoadingMessage']>) {
      state.postRequestLoadingMessage = action.payload;
    },
    setCompany(state, { payload }: PayloadAction<AppState['company']>) {
      state.company = payload;
    },
    setBulkSearchResults(state, { payload }: PayloadAction<AppState['bulkSearchResults']>) {
      state.bulkSearchResults = payload;
    }
  }
});

export const { showLoader: setLoader, setUser, setAcuityContext, setAccessToken, setCompany, setBulkSearchResults, setPostRequestLoadingMessage } = appSlice.actions;
